import { openDB } from 'idb';

export const dbPromise = openDB('OfflineInvoiceDB', 1, {
	upgrade(db) {
		if (!db.objectStoreNames.contains('invoices')) {
			db.createObjectStore('invoices');
		}
	},
});
